import {
  AudienceAvenuesCard,
  CollaborationPortfolioCard,
  HorizontalDividerVector,
  MonetizationAvenueCard,
  PopupCard,
  ProfileButtonSelector,
  SectionCard,
  TagChip,
  UnlockForCollaborationCard,
  VerticalDividerVector,
} from "../../PublicProfile/Component";
import { FiShare } from "react-icons/fi";
import { FaArrowRight } from "react-icons/fa6";
import featureLogo from "../../PublicProfile/assets/featured.gif";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import mixpanel from "mixpanel-browser";
import { useInfluencer } from "@/Providers/Influencer";
import { useGeneralSettings } from "@/Providers/General";
import { useStaticData } from "@/Providers/Data";
import { twMerge } from "tailwind-merge";
import { useCookies } from "react-cookie";
import { Button } from "@/shadcnComponents/ui/button";
import axios from "axios";
import { InfoIcon, Magnet } from "lucide-react";
import { CgProfile, CgWebsite } from "react-icons/cg";
import { GiVideoConference } from "react-icons/gi";
import { PiHandshake } from "react-icons/pi";
import { BiDollarCircle } from "react-icons/bi";
import { BsArrowUpRightCircle } from "react-icons/bs";
import profilebuildinglogo from "../assets/loading-profile-building.gif";
import logo from "../assets/28d77fccd23e3a575539bfdb89fd3cf1.png";
import { LoginPopup } from "../CreatorLandingPage";

const host = import.meta.env.VITE_BACKEND_SERVER_URL;

const TaglineList = [
  "Bringing ideas to life through content",
  "Driving impact, one collaboration at a time",
  "Influencing change with every post",
  "Crafting stories that inspire",
  "Connecting audiences through creativity",
  "Empowering brands with impactful content",
  "Architect of brand narratives",
  "Elevating brands through innovative storytelling",
  "Creating compelling journeys for brands",
  "Shaping perceptions with creative flair",
  "I build brand affinity through authentic voices",
];

const MyExpertiseList = [
  {
    icon: <CgProfile size={24} />,
    title: "Personal Branding",
    description:
      "Having a personal brand gives you an edge over your competitors. I can help you build a powerful personal brand.",
  },
  {
    icon: <GiVideoConference size={24} />,
    title: "1:1 Consultation for Brands",
    description:
      "Not sure where to start and which approach to take on LinkedIn? Let’s talk!",
  },
  {
    icon: <CgWebsite size={24} />,
    title: "Manage Company Page",
    description:
      "A credible LinkedIn page brings you better prospects & hires. Let’s make your work for you.",
  },
  {
    icon: <PiHandshake size={24} />,
    title: "Brand Collaboration",
    description:
      "Wide reach, conversions, PR or hiring. Everything is possible with an influential voice. Let’s partner up!",
  },
  {
    icon: <BiDollarCircle size={24} />,
    title: "Affiliate Marketing",
    description:
      "A good product/service deserves to sell & I can do it for you. Win-win. What say?",
  },
];

const DummyCreatorData = {
  success: true,
  data: {
    _id: "65a913ee686ddfd2e883fa55",
    name: "Ravi Ahirwar",
    profile:
      "https://media.licdn.com/dms/image/D4D03AQFSxQcmkzSYww/profile-displayphoto-shrink_200_200/0/1693739553701?e=2147483647&v=beta&t=aNbkfMztzDx_UaESIiSYl13ChhwTg0elvFg3AFpe7Y0",
    linkedinLink: "https://www.linkedin.com/in/ravi-x-anchors/",
    referal_code: "8011",
    coverPhoto: "",
    fbLink: "",
    instaLink: "",
    tagline: "Building anchors | a go-to platform for creators | IITB",
    telegramLink: "",
    twitterLink: "",
  },
  data2: {
    data: [
      {
        collabVerification: {
          isVerified: 1,
          status: 1,
          rating: 0,
        },
        companyName: "Company",
        companyUrl: "https://www.linkedin.com/company/dummy_company/",
        companyProfile: "",
        postLink: "https://www.linkedin.com/posts/dummy_post",
        goals: ["Your Goals", "Your Goals"],
        oldgoals: ["Awareness", "Traffic"],
      },
      {
        collabVerification: {
          isVerified: 0,
          status: 0,
          rating: 0,
        },
        companyName: "Company",
        companyUrl: "https://www.linkedin.com/company/dummy_company/",
        companyProfile: "",
        postLink: "https://www.linkedin.com/posts/dummy_post",
        goals: ["Your Goals", "Your Goals"],
        oldgoals: ["Awareness", "Traffic"],
      },
      {
        collabVerification: {
          isVerified: 0,
          status: 0,
          rating: 0,
        },
        companyName: "Company",
        companyUrl: "https://www.linkedin.com/company/dummy_company/",
        companyProfile: "",
        postLink: "https://www.linkedin.com/posts/dummy_post",
        goals: ["Your Goals", "Your Goals"],
        oldgoals: ["Awareness", "Traffic"],
      },
    ],
  },
  data3: {
    data: [
      {
        platformName: "Platform Name",
        oldplatformName: "Topmate",
        profileLink: "https://dummy.url/",
        paidAudience: 100,
        methods: ["662f9b4be24af60176edb1c1", "662f9b4be24af60176edb1bf"],
        oldmethods: ["1:1 Session", "Consulting"],
        _id: "65bf40eb77f1166ab8e04d31",
      },
      {
        platformName: "Platform Name",
        oldplatformName: "Topmate",
        profileLink: "https://dummy.url/",
        paidAudience: 100,
        methods: ["662f9b4be24af60176edb1c1", "662f9b4be24af60176edb1bf"],
        oldmethods: ["1:1 Session", "Consulting"],
        _id: "65bf40eb77f1166ab8e04d31",
      },
    ],
  },
  data4: {
    _id: "65bf411777f1166ab8e04d42",
    categories: [
      "663083e9e75cb2374719ed07",
      "663083e9e75cb2374719ecfe",
      "663083e9e75cb2374719ed0c",
      "663083e9e75cb2374719ed09",
      "663083e9e75cb2374719ed0f",
      "663083e9e75cb2374719ed0a",
      "663083e9e75cb2374719ed06",
    ],
    formats: [
      "66309be72b7d1bf27b433898",
      "66309be72b7d1bf27b433899",
      "66309be72b7d1bf27b43389a",
      "66309be72b7d1bf27b43389b",
      "66309be72b7d1bf27b43389c",
      "66309be72b7d1bf27b43389d",
    ],
    oldcategories: [
      "Leadership",
      "Career Development",
      "Startup Insights",
      "Personal Branding",
      "Upskilling",
      "Personal Development",
      "Interview Prep",
    ],
    oldformats: [
      "Long Form Videos",
      "Short-Form Videos",
      "Written Content",
      "Audio",
      "Livestreams",
      "Memes",
    ],
  },
  data5: {
    _id: "65bf417177f1166ab8e04d53",
    types: [
      "6633cbf7090985e049a2a33d",
      "6633cbf7090985e049a2a33e",
      "6633cbf7090985e049a2a33f",
      "6633cbf7090985e049a2a341",
      "6633cbf7090985e049a2a342",
      "6633cbf7090985e049a2a343",
      "6633cbf7090985e049a2a345",
      "6633cbf7090985e049a2a346",
      "6633cbf7090985e049a2a347",
      "6633cbf7090985e049a2a34b",
      "6633cbf7090985e049a2a349",
      "6633cbf7090985e049a2a340",
      "6633cbf7090985e049a2a344",
    ],
    platforms: [
      {
        oldplatform: "LinkedIn Profile",
        audience: 81135,
        link: "https://www.linkedin.com/in/palakh-khanna/",
        _id: "65bf417177f1166ab8e04d54",
      },
      {
        platform: "662fe6c5265afa0e90cab724",
        oldplatform: "Instagram Page",
        audience: 4032,
        link: "https://www.instagram.com/palakhkhanna20/",
        _id: "65bf417177f1166ab8e04d55",
      },
    ],
    oldtypes: [
      "Under Grad Students",
      "Techies Students",
      "Techies Professional",
      "Professional (Tech)",
      "Professional (Non-tech)",
      "Founder",
      "HR",
      "Marketing Professionals",
      "Consultants",
      "Creatives Writer",
      "Healthcare Professionals",
      "Corporate employee",
      "C-level",
    ],
  },
};

type UnlockPopupProps = {
  slug: string;
  onClose: () => void;
  title?: string;
  icon?: string;
  body?: string;
  buttonText?: string;
};

const UnlockPopup: React.FC<UnlockPopupProps> = ({
  slug,
  onClose,
  title,
  icon,
  body,
  buttonText,
}) => {
  const [cookies, setCookie] = useCookies();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    mixpanel.track(` ${buttonText} Popup Button clicked`);
    setCookie("unlockCreatorSearch", slug, { maxAge: 86400 });
    navigate("/Brand/DashBoard/UnlockInfluencerSearch");
  };

  return (
    <PopupCard onClose={onClose}>
      <div className="flex flex-col text-center gap-4 text-[#FFF] font-Inter not-italic w-full">
        <div className="text-[32px] font-semibold leading-[normal]">{icon}</div>
        <div className="flex flex-col gap-2">
          <div className="text-[16px] font-semibold leading-[18px]">
            {title}
          </div>
          <div className="text-[#9093AA] text-[12px] font-normal leading-[18px]">
            {body}
          </div>
        </div>
        <div>
          <Button variant="destructive" onClick={() => handleSubmit()}>
            <span className="text-[14px] font-semibold leading-[24px]">
              {buttonText}
            </span>
          </Button>
        </div>
      </div>
    </PopupCard>
  );
};

type themeColorType = {
  color: string[];
  bg: string[];
  from: string[];
  iconbg: string[];
};

const themeColor: themeColorType = {
  color: ["#171717", "#0D0D0D", "#181414", "#100F0A", "#0E0E15"],
  bg: [
    "bg-[#171717]",
    "bg-[#0D0D0D]",
    "bg-[#181414]",
    "bg-[#100F0A]",
    "bg-[#0E0E15]",
  ],
  from: [
    "from-[#171717]",
    "from-[#0D0D0D]",
    "from-[#181414]",
    "from-[#100F0A]",
    "from-[#0E0E15]",
  ],
  iconbg: [
    "bg-[#3e1a1a]",
    "bg-[#3d371b]",
    "bg-[#403e40]",
    "bg-[#182330]",
    "bg-[#210b43]",
  ],
};

export const GuestSampleProfile: React.FC = () => {
  const query = new URLSearchParams(window.location.search);
  const slug = query?.get("s");

  // Hooks ----------
  const targetRef = useRef(null);
  const targetRef2 = useRef(null);
  const Initialize = useRef(false);

  // States --------------
  const [InfluData, setInfluData] = useState({});
  const [topInfluencer, setTopInfluencer] = useState([]);
  const [openUnlockPopup, setOpenUnlockPopup] = useState(false);
  const [openCollabPopup, setOpenCollabPopup] = useState(false);
  const [isVisibleFloater, setIsVisibleFloater] = useState(false); // for floater visibility
  const [themeColorState, setThemeColorState] = useState({
    bgColorClass: "",
    gradientColorFromClass: "",
    IconBgClass: "",
  });
  const [tagline, setTagline] = useState(
    TaglineList[Math.floor(Math.random() * TaglineList.length)]
  );
  const [loadingText, setLoadingText] = useState("Analysing Profile...");

  const [openLoginPopup, setOpenLoginPopup] = useState(false); // for login popup

  const [isProfileLoading, setIsProfileLoading] = useState(false);

  useEffect(() => {
    const setDummyProfile = () => {
      document.title = `Dummy Profile - anchors | collab`;

      setInfluData({
        ...InfluData,
        profileData: {
          name: DummyCreatorData?.data?.name,
          about: DummyCreatorData?.data?.tagline,
          profile: DummyCreatorData?.data?.profile,
          linkedinLink: DummyCreatorData?.data?.linkedinLink,
        },
        collabHistory: DummyCreatorData?.data2?.data,
        monetizationChannels: DummyCreatorData?.data3?.data,
        contentCategories: DummyCreatorData?.data4?.oldcategories,
        contentFormat: DummyCreatorData?.data4?.oldformats,
        audiencePlatform: DummyCreatorData?.data5?.platforms,
        audienceTypes: DummyCreatorData?.data5?.oldtypes,
      });
    };

    setDummyProfile();
  }, []);

  useEffect(() => {
    async function fetchMetaData(slug: string) {
      setIsProfileLoading(true);
      try {
        if (slug) {
          const res = await axios.get(`${host}/in/li-guest-user?slug=${slug}`);

          const { data } = res;
          if (data.success) {
            setInfluData((prev) => {
              return {
                ...prev,
                profileData: {
                  ...prev?.profileData,
                  name: data?.data.name,
                  about: data?.data.about,
                  experience: data?.data.experience,
                  education: data?.data.education,
                  location: data?.data.location,
                  connections: data?.data.connections,
                  title: data?.data.title,
                  profile: data?.data.image,
                  linkedinLink: data?.data.url,
                },
              };
            });

            document.title = `${
              data?.data?.name || "Your Profile Preview"
            } - anchors | collab`;
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        const loadingTextCounter = () => {
          // change loading text after 3 sec
          const timerId = setTimeout(() => {
            setLoadingText("Creating Media Kit Preview...");
          }, 3000);
          return () => clearTimeout(timerId);
        };

        loadingTextCounter();

        // hide loading window after 6 sec
        const timerId = setTimeout(() => {
          setIsProfileLoading(false);
        }, 6000);
        return () => clearTimeout(timerId);
      }
    }

    fetchMetaData(slug);
  }, []);

  // useEffect(() => {
  //   staticDataState?.getNewDataFromType("Content Type").then((e) => {
  //     setMasterContentCategory(e);
  //   });
  //   staticDataState?.getNewDataFromType("Content Format").then((e) => {
  //     setMasterContentFormat(e);
  //   });
  //   staticDataState?.getNewDataFromType("Audience Category").then((e) => {
  //     setMasterAudienceTypes(e);
  //   });
  //   staticDataState?.getNewDataFromType("Audience Platform").then((e) => {
  //     setMasterAudiencePlatfroms(e);
  //   });
  //   staticDataState?.getNewDataFromType("Goal / KPI").then((e) => {
  //     setMasterCollabGoals(e);
  //   });
  //   staticDataState?.getNewDataFromType("Platform Name").then((e) => {
  //     setMasterMonetizationPlatform(e);
  //   });
  //   staticDataState?.getNewDataFromType("Services list").then((e) => {
  //     setMasterMonetizationServices(e);
  //   });
  // }, []);

  // Effects  ---------------------------

  // Dynamic Theme Color
  useEffect(() => {
    const randomColor = (listOfColor: themeColorType) => {
      const index = Math.floor(Math.random() * listOfColor?.bg?.length);
      return [
        listOfColor?.bg[index],
        listOfColor?.from[index],
        listOfColor?.iconbg[index],
      ];
    };

    if (themeColor) {
      const indx = randomColor(themeColor);

      setThemeColorState({
        bgColorClass: indx[0],
        gradientColorFromClass: indx[1],
        IconBgClass: indx[2],
      });
    }
  }, [themeColor]);

  return (
    <>
      {openLoginPopup && (
        <LoginPopup onClose={() => setOpenLoginPopup(false)} />
      )}

      {isProfileLoading ? (
        <div className="w-screen h-screen fixed top-0 left-0 bottom-0 right-0 z-[110] bg-[#000000] text-white">
          <div className="relative size-full">
            <div className="w-full flex justify-between items-center p-4 absolute top-0 right-0">
              <img
                src={logo}
                alt=""
                className="h-fit w-20 md:w-32 cursor-pointer"
              />
            </div>
            <div className="w-full h-full flex items-center justify-center">
              <div className="flex flex-col justify-center items-center">
                <img src={profilebuildinglogo} alt="loading" className="w-36" />
                <p className="mt-3 font-thin">{loadingText}</p>
                <p className="text-xs text-gray-500">{slug}</p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={twMerge(
            `text-white min-h-svh bg-[#171717] md:px-[96px] md:py-[30px] relative`,
            `${themeColorState.bgColorClass}`
          )}
        >
          {/* ---------- info card ---------- */}
          <div className="flex gap-2 md:rounded-[8px] bg-[#2b2b31] border border-[#2b2b31] p-2 md:p-3 md:mb-4 items-center text-[#919191] font-[Inter] text-[12px] not-italic font-normal leading-[14px]">
            <InfoIcon size={16} className="shrink-0" />
            <span>
              This is a profile preview. Click on{" "}
              <b>Create your anchors Profile</b> button to create your own
              profile.
            </span>
          </div>

          {/* main */}
          <div className="md:flex md:gap-[28px] w-full h-max">
            {/* Creator Profile */}
            <section
              ref={targetRef}
              className="md:w-[365px] shrink-0  md:flex md:flex-col md:gap-[28px]"
            >
              <div className="md:p-[16px] md:rounded-[8px] md:border-[1px] md:border-solid md:border-[#262626]">
                <div className="relative h-[359px]">
                  <img
                    src={
                      InfluData?.profileData?.profile ||
                      "https://collab.anchors.in/FeatredCreatorBackground.png"
                    }
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src =
                        "https://collab.anchors.in/FeatredCreatorBackground.png";
                    }}
                    alt={`${InfluData?.profileData?.name} Pic`}
                    className="z-[1] object-cover h-full w-full md:rounded-[8px]"
                  />
                  <div
                    className={twMerge(
                      `z-[2] absolute top-0 left-0 right-0 bottom-0 bg-gradient-to-t from-[#171717] to-transparent`,
                      `${themeColorState.gradientColorFromClass}`
                    )}
                  >
                    <div className="flex flex-col justify-between w-full h-full">
                      <div></div>
                      <span className="w-full text-center text-white text-[40px] not-italic font-bold leading-[normal] font-[Inter] px-[16px]">
                        {InfluData?.profileData?.name}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="px-[16px]">
                  {topInfluencer.some(
                    (item) => item?._id === InfluData?.profileData?._id
                  ) && (
                    <div className="mt-[16px] flex justify-center">
                      <div className="flex justify-center items-center gap-2 px-3 py-1.5 rounded bg-[linear-gradient(92deg,_rgba(241,_241,_241,_0.16)_1.57%,_rgba(243,_171,_171,_0.00)_49.29%,_rgba(241,_241,_241,_0.20)_96.06%)]">
                        <div className="w-6 h-6">
                          <img
                            src={featureLogo}
                            alt="logo"
                            className="w-full h-full"
                          />
                        </div>
                        <span className="rounded text-white text-center text-xs not-italic font-bold leading-[normal] font-[Inter]">
                          FEATURED
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="mb-[32px] flex flex-col items-center gap-4">
                    <div
                      style={{
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 3,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "100%",
                      }}
                      className="text-[#D9D9D9] text-center text-sm not-italic font-normal leading-6 tracking-[0.14px] self-stretch"
                    >
                      {/* {InfluData?.profileData?.about} */}
                      {tagline}
                    </div>

                    {/* Social Links */}
                    <div
                      className="w-full flex justify-center  items-center overflow-x-auto"
                      style={{ scrollbarWidth: "none" }}
                    >
                      <div className="w-fit flex justify-center gap-3 flex-wrap">
                        <ProfileButtonSelector
                          profileData={InfluData?.profileData}
                          color={themeColorState.IconBgClass}
                        />
                      </div>
                    </div>
                  </div>

                  {/* ---------------- Claim your profile button ----------------- */}
                  <div className="fixed bottom-0 left-0 right-0 z-[4]">
                    <div className="w-full relative flex justify-center md:justify-end items-center p-3 md:p-4 md:pr-8 ">
                      <div className="flex flex-row items-center justify-center">
                        <div className="felx items-center justify-center animate-border inline-block rounded-[12px] bg-white bg-gradient-to-r from-red-500 via-purple-500 to-blue-500 bg-[length:400%_400%] p-[2px]">
                          <Button
                            className="inline-flex px-[15px] py-[24px] items-center rounded-[10px] bg-[#1e1c1c] text-[#efebeb]  hover:text-[#19191a] gap-2 hover:bg-[#d4d5d6] hover:animate-none"
                            onClick={() => {
                              mixpanel.track(
                                "Create your anchors Profile button clicked"
                              );
                              setOpenLoginPopup(true);
                            }}
                          >
                            <span className=" font-[Inter] text-[16px] not-italic font-medium leading-[24px]">
                              Create your anchors Profile
                            </span>
                            <BsArrowUpRightCircle size={25} />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* CTA Button --- floater Button */}
                  <div
                    className={twMerge(
                      `flex items-start gap-[16px] ${
                        isVisibleFloater &&
                        "bg-[#0E0E15] z-[5] bottom-0 left-0 right-0 p-4 fixed"
                      }`,
                      `${themeColorState.bgColorClass}`
                    )}
                  >
                    <button
                      className="cursor-not-allowed flex px-[16px] py-[8px] justify-center items-center gap-[10px] self-stretch rounded-[6px] bg-[#E2E8F0]"
                      onClick={() => {
                        mixpanel.track("share profile");
                        // handleShare();
                      }}
                    >
                      <FiShare size={20} color="#000000" />
                    </button>

                    {/* collaborate with me button */}
                    <button
                      className="cursor-not-allowed flex px-[16px] py-[8px] justify-center items-center gap-[10px] flex-[1_0_0] rounded-[6px] bg-[#DC2627]"
                      onClick={() => {
                        mixpanel.track("Collaborate with me");
                        // setOpenCollabPopup(true);
                      }}
                    >
                      <span className="text-[#FFF] text-[14px] not-italic font-medium leading-[24px] font-[Inter]">
                        Collaborate with me
                      </span>
                      <FaArrowRight size={16} color="#FFF" />
                    </button>
                  </div>
                </div>
              </div>

              {/* Unlock for collaboration! - desktop */}
              <section className="hidden md:block">
                <UnlockForCollaborationCard
                  onUnlockClick={() => {
                    mixpanel.track("Unlock button click");
                    // setOpenUnlockPopup(true);
                  }}
                  onCollabClick={() => setOpenCollabPopup(true)}
                />
              </section>
            </section>

            {/* Vertical Divider */}
            <div className="md:hidden">
              <VerticalDividerVector />
            </div>

            {/* Creator Data Section*/}
            <section ref={targetRef2} className="px-[16px] md:px-0 w-full">
              {/* ------------- MyExpertise Section -------------- */}
              {MyExpertiseList?.length > 0 && (
                <>
                  <div className="w-full">
                    <SectionCard
                      title="My expertise"
                      subtitle="Like you know your business, I know LinkedIn. Here are some things I can do for you"
                    >
                      <div className="flex items-start flex-wrap gap-[20px]">
                        {MyExpertiseList.map((data, index) => {
                          return (
                            <MyExpertiseCard
                              key={index}
                              icon={data?.icon}
                              title={data?.title}
                              description={data?.description}
                            />
                          );
                        })}
                      </div>
                    </SectionCard>
                  </div>
                </>
              )}

              {/* Collaboration Porfolio/Collaboration History ------------------------- */}
              {InfluData?.collabHistory?.length > 0 && (
                <>
                  <VerticalDividerVector />

                  <div className="">
                    <SectionCard
                      icon={"🫱🏼‍🫲🏽"}
                      title="Collaboration History"
                      subtitle="Brands I've partnered with in the past"
                    >
                      <div className="flex items-start flex-wrap gap-[20px]">
                        {InfluData?.collabHistory?.map((data, index) => {
                          return (
                            data?.companyName?.trim().length > 0 && (
                              <CollaborationPortfolioCard
                                key={index}
                                companyName={data?.companyName}
                                companyProfile={data?.companyProfile}
                                companyUrl={data?.companyUrl}
                                goals={data?.oldgoals}
                                postLink={data?.postLink}
                                status={data?.collabVerification?.status}
                                isBlur={true}
                              />
                            )
                          );
                        })}
                      </div>
                    </SectionCard>
                  </div>
                </>
              )}

              {/* Monetization Avenue/Monetization Channels ------------------------- */}
              {InfluData?.monetizationChannels?.length > 0 && (
                <>
                  <VerticalDividerVector />

                  <div className="">
                    <SectionCard
                      icon={"💰"}
                      title="Monetization Channels"
                      subtitle="Platforms where I monetize my content & reach"
                    >
                      <div className="flex items-start flex-wrap gap-[20px] w-full">
                        {InfluData?.monetizationChannels?.map((data, index) => {
                          return (
                            <MonetizationAvenueCard
                              key={index}
                              platformname={data?.platformName}
                              profileLink={data?.profileLink}
                              paidAudience={data?.paidAudience}
                              methods={data?.oldmethods}
                              isBlur={true}
                            />
                          );
                        })}
                      </div>
                    </SectionCard>
                  </div>
                </>
              )}

              {/* Content Category/Content Focus --------------------------*/}
              {InfluData?.contentCategories?.length > 0 && (
                <>
                  <VerticalDividerVector />

                  <div className="">
                    <SectionCard
                      icon={"💭"}
                      title="Content Focus"
                      subtitle="Niche categories & topics I majorly focus on"
                    >
                      <div className="flex items-start gap-[8px] flex-wrap filter blur-sm">
                        {InfluData?.contentCategories
                          ?.slice(0, 6)
                          .map((data, index) => {
                            return <TagChip key={index} title={data} />;
                          })}
                        {InfluData?.contentCategories?.length > 6 && (
                          <TagChip
                            title={`+${
                              InfluData?.contentCategories?.length - 6
                            }`}
                          />
                        )}
                      </div>
                    </SectionCard>
                  </div>
                </>
              )}

              {/* Content Formats ---------------------*/}
              {InfluData?.contentFormat?.length > 0 && (
                <>
                  <VerticalDividerVector />

                  <div className="">
                    <SectionCard
                      icon={"💭"}
                      title="Content Formats"
                      subtitle="Format styles that I am most comfortable with"
                    >
                      <div className="flex items-start gap-[8px] flex-wrap filter blur-sm">
                        {InfluData?.contentFormat
                          ?.slice(0, 6)
                          .map((data, index) => {
                            return <TagChip key={index} title={data} />;
                          })}
                        {InfluData?.contentFormat?.length > 6 && (
                          <TagChip
                            title={`+${InfluData?.contentFormat?.length - 6}`}
                          />
                        )}
                      </div>
                    </SectionCard>
                  </div>
                </>
              )}

              {/* Audience Types --------------------*/}
              {InfluData?.audienceTypes?.length > 0 && (
                <>
                  <VerticalDividerVector />

                  <div className="">
                    <SectionCard
                      icon={"👩🏻‍🤝‍👩🏼"}
                      title="Audience Types"
                      subtitle="Demographics of my audience & community"
                    >
                      <div className="flex items-start gap-[8px] flex-wrap filter blur-sm">
                        {InfluData?.audienceTypes
                          ?.slice(0, 6)
                          .map((data, index) => {
                            return <TagChip key={index} title={data} />;
                          })}
                        {InfluData?.audienceTypes?.length > 6 && (
                          <TagChip
                            title={`+${InfluData?.audienceTypes?.length - 6}`}
                          />
                        )}
                      </div>
                    </SectionCard>
                  </div>
                </>
              )}

              {/* Audience Avenues/Platform Presence --------------------------*/}
              {InfluData?.audiencePlatform?.filter(
                (data) => data?.oldplatform !== "LinkedIn Profile"
              )?.length > 0 && (
                <>
                  <VerticalDividerVector />

                  <div className="">
                    <SectionCard
                      icon={"👩🏻‍🤝‍👩🏼"}
                      title="Platform Presence"
                      subtitle="Platforms I have a strong reach & community on"
                    >
                      <div className="flex items-start gap-[20px] self-stretch flex-wrap">
                        {InfluData?.audiencePlatform?.map((data, index) => {
                          return (
                            data?.audience > 0 &&
                            data?.platform && (
                              <AudienceAvenuesCard
                                key={index}
                                platform={data?.oldplatform}
                                audience={data?.audience}
                                // link={data?.link}
                                icon={
                                  "https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/Instagram.svg"
                                }
                                isBlur={true}
                              />
                            )
                          );
                        })}
                      </div>
                    </SectionCard>
                  </div>
                </>
              )}
            </section>
          </div>

          {/* Unlock for collaboration! - mobile */}
          <section className="md:hidden">
            <div className="px-[16px] py-[32px]">
              <UnlockForCollaborationCard
                onUnlockClick={() => {
                  mixpanel.track("Unlock button click");
                  setOpenUnlockPopup(true);
                }}
                onCollabClick={() => setOpenCollabPopup(true)}
              />
            </div>
          </section>

          {/* Horizontal Divider */}
          <div className="md:pt-[56px] md:pb-[20px]">
            <HorizontalDividerVector width="w-[174px] md:max-w-[1248px]" />
          </div>

          {/* Footer */}
          <section className="pb-[75px] pt-[20px] flex items-center justify-center md:p-0">
            <div className="flex flex-col justify-center items-center gap-[20px] w-fit md:w-full md:flex-row md:justify-between">
              <div className="text-[rgba(163,_163,_163,_0.67)] text-center font-[Inter] text-[12px] not-italic font-normal leading-[18px]">
                <span>{"Powered by "}</span>
                <a
                  href="http://anchors.in"
                  target="_blank"
                  className="font-bold hover:underline"
                  onClick={() => mixpanel.track("Clicked Powered by Anchors")}
                >
                  anchors.in
                </a>
              </div>

              {/* Button */}
            </div>
          </section>
        </div>
      )}
    </>
  );
};

type MyExpertiseCardProps = {
  icon?: any;
  title: string;
  description?: string;
};

const MyExpertiseCard = ({
  icon,
  title,
  description,
}: MyExpertiseCardProps) => {
  return (
    <div className="flex w-full self-stretch md:w-[271px] px-[16px] py-[12px] flex-col items-start gap-[20px] flex-shrink-0 rounded-[6px] bg-[rgba(38,_38,_38,_0.44)]">
      {icon && (
        <div className="flex justify-between">
          <div className="flex w-[33px] h-[33px] pt-[4px] pr-[4px] pb-[5px] pl-[5px] justify-center items-center rounded-[5px] bg-[#535353]">
            {icon}
          </div>
        </div>
      )}
      <div className="flex flex-col items-start gap-[8px] self-stretch">
        <div className="text-[#E2E8F0] font-[Inter] text-[14px] not-italic font-medium leading-[normal]">
          {title}
        </div>
        {description && (
          <div className="text-[#919191] font-[Inter] text-[12px] not-italic font-normal leading-[20px]">
            {description}
          </div>
        )}
      </div>
    </div>
  );
};
